export default function contactUsSubjectReducer(state = {contactUsSubjectState: []}, action) {
          switch (action.type) {
              case 'CONTACTUSSUBJECT_STATE':
                  return {
                    contactUsSubjectState: action.contactUsSubjectState,
                  }
      
              default:
                  return state
          }
      }


// WEBPACK FOOTER //
// ./src/reducer/contactussubject.jsx